const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '立项信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/dycq/startCQ.do`, {
                approvalId: this.form.approveRecordId,
            }).then((res) => {
                this.config[1].options.data = {
                    '项目名称': res.data.projectName,
                    '项目编号': res.data.projectNo,
                    '项目所属区域': res.data.projectArea,
                    '项目实施地点': res.data.projectShishiPlace,
                    '项目类型': getProjectTypeName(res.data.projectType),
                    '估算金额(万元)': res.data.estimatedAmount,
                    '采购方式': getPurchaseTypeName(res.data.tenderWay),
                    '竞价方式': res.data.supplierSource === 1 ? '公开' : '邀请',
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
